import axios from 'axios';

export function logError(message: string, payload?: any) {
  try {
    axios.post('/api/error', { message, payload });
  } catch (error) {}
}

export function logInfo(message: string, payload?: any) {
  try {
    axios.post('/api/error', { message, payload, type: 'info' });
  } catch (error) {}
}
